import { render, staticRenderFns } from "./TeacherManage.vue?vue&type=template&id=633bfe07&scoped=true"
import script from "./TeacherManage.vue?vue&type=script&lang=js"
export * from "./TeacherManage.vue?vue&type=script&lang=js"
import style0 from "./TeacherManage.vue?vue&type=style&index=0&id=633bfe07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633bfe07",
  null
  
)

export default component.exports